import { getCostCenter } from "./CostCenterAction";

const dispatchGetCostCenter = (dispatch: Function) => (val : any) => {
    dispatch(getCostCenter(val));
};

const CostCenterDispatch = {
    dispatchGetCostCenter
};

export default CostCenterDispatch